module.exports = __webpack_public_path__ + "static/img/bg_low2@2x.eb1d8e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_low2@2x.png
// module id = /n7t
// module chunks = 1